/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconQualification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconQualification"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2a7 7 0 0 1 5.002 11.897L17 22.618l-5-2.5-5 2.5v-8.72A7 7 0 0 1 12 2m3 13.326A7 7 0 0 1 12 16a7 7 0 0 1-3-.674v4.056l3-1.5 3 1.5zM12 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    />
  </svg>
);
export default IconQualification;
